<template>
  <v-container fluid>
    <v-row>
      <!-- <v-col cols="12" lg="6">
              <div class="inside">
        <v-col class="my-0 py-0" cols="12">
          <div class="d-flex justify-center">
            <v-subheader class="headline font-weight-bold">Student Count By Type</v-subheader>
          </div>
        </v-col>
        <v-col v-for="(typeCount,i) in  studentstrengthTypeCountData " :key="i" cols="12" sm="6" md="3" lg="4">
          <v-card class="mx-auto" max-width="344">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1">
                  {{ typeCount.totalstudentClassCount }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ typeCount.type !== null ? typeCount.type : 'other' }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </v-card>
        </v-col>
      </div>
              </v-col> -->
      <v-row no-gutters>
        <v-col
          v-if="this.studentstrengthCategoryCountData.length > 0"
          cols="12"
          lg="6"
        >
          <div class="inside">
            <v-col class="my-0 py-0" cols="12">
              <div class="d-flex justify-center">
                <v-subheader class="headline font-weight-bold"
                  >Student Count By Category</v-subheader
                >
              </div>
            </v-col>
            <v-col
              v-for="(catogoryCount, i) in studentstrengthCategoryCountData"
              :key="i"
              cols="12"
              sm="6"
              md="3"
              lg="4"
            >
              <v-card
                rounded="lg"
                color="success"
                dark
                class="mx-auto pl-1"
                width="190px"
                max-width="344"
              >
                <div style="background-color: white">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-title class="text-h5 mb-1 black--text">
                        {{ catogoryCount.totalstudentClasscateogoryCount }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="black--text">{{
                        catogoryCount.cateogory !== null
                          ? catogoryCount.cateogory
                          : 'other'
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-card>
            </v-col>
          </div>
        </v-col>
        <v-col v-if="studentstrengthTypeCountData.length > 0" cols="12" lg="6">
          <div class="inside">
            <v-col class="my-0 py-0" cols="12">
              <div class="d-flex justify-center">
                <v-subheader class="headline font-weight-bold"
                  >Student Count By Type</v-subheader
                >
              </div>
            </v-col>
            <v-col
              v-for="(typeCount, i) in studentstrengthTypeCountData"
              :key="i"
              cols="12"
              sm="6"
              md="3"
              lg="4"
            >
              <v-card
                rounded="lg"
                color="error"
                dark
                class="mx-auto pl-1"
                width="190px"
                max-width="344"
              >
                <div style="background-color: white">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-title class="text-h5 mb-1 black--text">
                        {{ typeCount.totalstudentClassCount }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="black--text">{{
                        typeCount.type !== null ? typeCount.type : 'other'
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-card>
            </v-col>
          </div>
        </v-col>
      </v-row>
      <div v-if="classes.length > 0" class="inside">
        <v-col class="my-0 py-0" cols="12">
          <div class="d-flex justify-center">
            <v-subheader class="headline font-weight-bold"
              >Student Count By Class</v-subheader
            >
          </div>
        </v-col>
        <v-col
          v-for="(classs, i) in classes"
          :key="i"
          cols="12"
          sm="6"
          md="3"
          lg="2"
        >
          <v-card
            rounded="lg"
            color="black"
            dark
            class="mx-auto pl-1"
            max-width="344"
          >
            <v-list-item style="background-color: white" three-line>
              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1 black--text">
                  {{ classs.studentClassCount }}
                </v-list-item-title>
                <v-list-item-subtitle class="black--text">{{
                  classs.name
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-menu
                top
                :close-on-content-click="false"
                open-on-hover
                :nudge-width="0"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-card-actions class="mt-0 pt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                      color="black"
                      small
                      outlined
                      rounded
                      text
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-filter-variant</v-icon>
                    </v-btn>
                  </v-card-actions>
                </template>
                <v-card>
                  <v-list class="py-0" outlined>
                    <v-list-item-group
                      color="primary"
                      v-for="sec in classs.studentSections"
                      :key="sec.id"
                    >
                      <v-list-item class="px-8">
                        <v-list-item-content>
                          <v-list-item-subtitle
                            v-text="sec.name"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-list-item-title
                            class="body-2"
                            v-text="sec.studentSectionCount"
                          ></v-list-item-title>
                        </v-list-item-icon>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-menu>
            </v-list-item>
          </v-card>
          <!-- <material-card icon="mdi-google-classroom" :smalltitle="classs.name" :vsmallvalue="classs.studentClassCount">
            <v-menu top :close-on-content-click="false" open-on-hover :nudge-width="0" offset-y>
             <template v-slot:activator="{ on, attrs }">
               <v-card-actions>
                 <v-spacer></v-spacer>
                 <v-btn icon color="primary" min-width="0" small right v-bind="attrs" v-on="on">
               <v-icon size="30">mdi-chevron-down </v-icon>
              </v-btn>
               </v-card-actions>
            </template>
             <v-card>
               <v-list class="py-0" outlined>
                <v-list-item-group color="primary" v-for="sec in classs.studentSections" :key="sec.id">
                  <v-list-item class="px-8">
                    <v-list-item-content>
                      <v-list-item-subtitle v-text="sec.name"></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-list-item-title class="body-2" v-text="sec.studentSectionCount"></v-list-item-title>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
               </v-list>
              </v-card>
            </v-menu>
          </material-card> -->
        </v-col>
      </div>
    </v-row>
    <loading-icon :value="isLoading" />
    <material-card
      icon="mdi-clipboard-text"
      inline
      title="Student Count By Franchisee"
    >
      <v-card-text
        class="pt-0 pr-1"
        :class="{
          'd-block py-3': $vuetify.breakpoint.xs,
          'd-flex align-center': $vuetify.breakpoint.smAndUp
        }"
      >
        <v-text-field
          :class="{
            'mr-0': $vuetify.breakpoint.xs,
            'mr-5': $vuetify.breakpoint.smAndUp
          }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width: 350px"
        />
      </v-card-text>
      <v-divider class="my-0" />
      <v-data-table
        :single-expand="true"
        item-key="id"
        :search.sync="search"
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }"
        :items-per-page="5"
        :headers="headers"
        :items="studentstrengthData"
      >
        <template v-slot:item.actions="{ item }">
          <router-link
            :to="{
              name: 'studentDetail',
              params: {
                ClassId: item.ClassId,
                FranchiseeId: item.FranchiseeId,
                SectionId: item.SectionId
              }
            }"
          >
            <v-btn
              color="darkblue"
              class="white--text px-2 ml-1 ma-1"
              min-width="0"
              small
            >
              <v-icon small> mdi-equalizer </v-icon>
            </v-btn>
          </router-link>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import constants from '@/utils/constants'
import _ from 'lodash'
import MaterialCard from '../../template/MaterialCard.vue'
import Utils from '@/utils'

export default {
  components: { MaterialCard },
  data () {
    return {
      franchiseeID: '',
      academicYearID: '',
      inProgress: false,
      staffCount: null,
      isLoading: false,
      search: '',
      classes: [],
      studentstrengthData: [],
      studentstrengthCategoryCountData: [],
      studentstrengthTypeCountData: [],
      headers: [
        {
          text: 'Franchisee Name',
          value: 'franchisee.companyName',
          sortable: true
        },
        { text: 'Class', value: 'studentClass.name', sortable: true },
        { text: 'Section', value: 'studentSection.name', sortable: true },
        { text: 'Count', value: 'studentSectionCount', sortable: true },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  created: async function () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },

    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.academicYearID) {
          await this.getStudentCount()
          await this.getstudentstrengthData()
        }

        this.inProgress = false
      }
    },
    getStudentCount: async function () {
      try {
        this.isLoading = true
        let url = `${constants.API_URL}/api/student/all-count?isAllValue=true&&academicYearID=${this.academicYearID}`
        url += this.franchiseeID ? `&&franchiseeID=${this.franchiseeID}` : ''
        let response = await http.get(url)
        const data = response.data
        this.classes = data
        let resultant = _.map(_.groupBy(data, 'category'), (obj) => {
          return _.map(obj, (ele) => {
            ele.totalstudentClassCount = _.sumBy(obj, 'studentClassCount')
            return {
              totalstudentClasscateogoryCount: ele.totalstudentClassCount,
              cateogory: ele.category
            }
          })
        })
        this.studentstrengthCategoryCountData = _.map(resultant, 0)
        let resultants = _.map(_.groupBy(data, 'type'), (obj) => {
          return _.map(obj, (ele) => {
            ele.totalstudentClassCountbyType = _.sumBy(obj, 'studentClassCount')
            return {
              totalstudentClassCount: ele.totalstudentClassCountbyType,
              type: ele.type
            }
          })
        })
        this.studentstrengthTypeCountData = _.map(resultants, 0)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        return false
      } finally {
        this.isLoading = false
      }
    },
    getstudentstrengthData: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${constants.API_URL}/api/get-studentstrength?academicYearID=${this.academicYearID}`
        )
        this.studentstrengthData = res.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style scoped></style>
